import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { DirectService } from 'src/app/shared/services/user/direct.service';

@Component({
  selector: 'app-direct-block',
  templateUrl: './direct-block.component.html',
  styleUrls: ['./direct-block.component.scss'],
})
export class DirectBlockComponent implements OnInit {
  @Input() content;
  @Input() showTitle = true;
  @Input() useUrl = true;

  constructor(
    private directService: DirectService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (!this.useUrl) {
      this.content.url = '';
    }
    setTimeout(() => {
      // wait for DOM rendering
      this.directService.reinsertLinks(this.elementRef, this.renderer);
    });
  }
}
